export const dimensionQueryKeyMap = {
    all: () => ['dim/all'],
    dimension: (id: number) => [
        ...dimensionQueryKeyMap.all(),
        `dim/${id}`,
        `dim/withBarredLines`,
        'dim/withBarredDims',
        'dim/withDistKeys',
    ],
    value: (id: number, dimId: number) => [...dimensionQueryKeyMap.dimension(dimId), `dim/value/${id}`],
    distribution: (id: number, dimId: number) => [...dimensionQueryKeyMap.dimension(dimId), `dim/distribution/${id}`],
} as const;
